import { NavigationItem } from "@/helpers/enums";

export const navigationItems = {
  [NavigationItem.Expertise]: {
    name: "Expertise",
    href: null,
    id: NavigationItem.Expertise,
  },
  [NavigationItem.About]: {
    name: "Über",
    href: null,
    id: NavigationItem.About,
  },
  [NavigationItem.Blog]: { name: "Blog", href: "/blog", id: null },
  [NavigationItem.Contact]: {
    name: "Kontakt",
    href: null,
    id: NavigationItem.Contact,
  },
};
